import React from 'react'
import t from '~t'
import { Helmet } from 'react-helmet'
import SplitView from '~co/screen/splitview'
import * as Sidebar from '~co/screen/splitview/sidebar'
import Main from '~co/screen/splitview/main'
import { Button, HeaderFirstAction as FirstAction, Avatar } from '~ui';

export default function SplashApp() {
    return (
        <SplitView>
            <Helmet><title>{t.s('loading')}…</title></Helmet>

            <Sidebar.default>
                <Sidebar.Header data-no-shadow>
                    <FirstAction>
                        <Button variant='ghost' disabled><Avatar /></Button>
                    </FirstAction>
                </Sidebar.Header>
            </Sidebar.default>
            <Main />
        </SplitView>
    )
}